import {useEffect, useMemo, useState} from "react";
import {EmptyMember} from "./EmptyMember";
import {Member} from "./Member";
import {useNavigate} from "react-router-dom";
import {useMembers} from "../../hooks/UseMembers";

export function MembersPanel(props) {
    const user = props.user;
    const membersHook = useMembers();
    const members = membersHook.members;

    const [onlyActive, setOnlyActive] = useState(true);

    const navigate = useNavigate();

    const onBackClicked = () => {
        navigate('/');
    }

    const onCreateClicked = async (genre) => {
        await membersHook.createMember(user.token, genre);
    }

    const onDeleteClicked = async (member) => {
        const confirmed = window.confirm(`Ви впевнені, що хочете видалити учасника "${member.nickName}"?`);
        if (confirmed) {
            await membersHook.deleteMember(user.token, member);
        }
    }

    const onToggleActive = async (member) => {
        await membersHook.updateMember(user.token, member);
        console.log(`Member ${member.nickName} is ${member.isActive ? 'active' : 'inactive'} now`);
    }

    useEffect(() => {
        membersHook.loadMembers(user.token);
    }, [user]);

    const memberElements = useMemo(() => {
        if (!members) return [];

        return members
            .filter(m => onlyActive ? m.isActive : true)
            .map(m => (
                <Member
                    member={m}
                    key={m.id}
                    onDeleteClicked={onDeleteClicked}
                    onToggleActive={onToggleActive}
                />
            ));
    }, [members, onlyActive]);

    return (
        members ?
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '20px',
                paddingLeft: '15px',
                paddingRight: '15px'
            }}>
                <button
                    onClick={onBackClicked}
                    style={{
                        marginBottom: '20px',
                        padding: '8px 20px',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        fontWeight: '600',
                        color: '#374151',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                        transition: '0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                >
                    ← Назад
                </button>

                <h2 style={{ margin: '0 0 20px 0', fontSize: '28px', color: '#111827' }}>Учасники</h2>

                {/* checkbox */}
                <div style={{
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 15px',
                    backgroundColor: '#f3f4f6',
                    borderRadius: '8px'
                }}>
                    <input
                        type="checkbox"
                        id="activeFilter"
                        checked={onlyActive}
                        onChange={(e) => setOnlyActive(e.target.checked)}
                        style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                    />
                    <label htmlFor="activeFilter" style={{ cursor: 'pointer', fontWeight: '500' }}>
                        Показувати лише активних
                    </label>
                </div>

                <EmptyMember onCreateClicked={onCreateClicked}/>

                <div style={{ marginTop: '20px' }}>
                    {memberElements.length > 0 ? memberElements : <div style={{color: '#9ca3af'}}>Нікого не знайдено</div>}
                </div>
            </div>
            :
            <div>завантаження...</div>
    );
}